import { h, forceUpdate } from "@stencil/core";
/**
 * Base header component that provides a flexible layout with optional slots for logo, meta navigation, search, and burger menu.
 * @slot logo - Container for the logo content
 * @slot meta-nav - Container for meta navigation elements
 * @slot search - Container for search functionality
 * @slot burger - Container for burger menu
 */
export class DcUiHeaderBase {
    constructor() {
        this.handleLanguageButtonMoved = () => {
            forceUpdate(this.el);
        };
        this.handleMutations = () => {
            forceUpdate(this.el);
        };
    }
    componentDidLoad() {
        // Listen for the custom event
        this.el.addEventListener('languageButtonMoved', this.handleLanguageButtonMoved);
        // Initialize MutationObserver
        this.observer = new MutationObserver(this.handleMutations);
        // Start observing the element for child changes
        this.observer.observe(this.el, {
            childList: true, // Watch for changes to child elements
        });
    }
    disconnectedCallback() {
        // Clean up listener and observer
        this.el.removeEventListener('languageButtonMoved', this.handleLanguageButtonMoved);
        this.observer.disconnect();
    }
    async returnSearchExpandSize() {
        try {
            if (!this.metaNavEl) {
                // Use percentage-based fallback
                return this.el.getBoundingClientRect().width * 0.5;
            }
            const gapBetweenMetaNavAndSearch = 48;
            const headerWidth = this.el.getBoundingClientRect().width;
            const metaNavWidth = this.metaNavEl.getBoundingClientRect().width;
            const searchWidth = this.searchEl.getBoundingClientRect().width;
            const width = metaNavWidth + searchWidth + gapBetweenMetaNavAndSearch;
            return Math.max(width, headerWidth * 0.5);
        }
        catch (error) {
            return this.el.getBoundingClientRect().width * 0.5;
        }
    }
    render() {
        // Check if slots have content
        const hasLogo = this.el.querySelector('[slot="logo"]');
        const hasMetaNav = this.el.querySelector('[slot="meta-nav"]');
        const hasSearch = this.el.querySelector('[slot="search"]');
        const hasBurger = this.el.querySelector('[slot="burger"]');
        // Build class string based on slot usage
        const classes = {
            'header-base-wrapper': true,
            'has-logo': !!hasLogo,
            'has-meta-nav': !!hasMetaNav,
            'has-search': !!hasSearch,
        };
        const burger = hasBurger ? (h("div", { class: "burger-wrapper" }, h("slot", { name: "burger" }))) : null;
        const logo = hasLogo ? (h("div", { class: "logo-wrapper" }, h("slot", { name: "logo" }))) : null;
        const metaNav = hasMetaNav ? (h("div", { class: "meta-nav-wrapper", ref: (el) => (this.metaNavEl = el) }, h("slot", { name: "meta-nav" }))) : null;
        const search = hasSearch ? (h("div", { class: "search-wrapper", ref: (el) => (this.searchEl = el) }, h("slot", { name: "search" }))) : null;
        return (h("div", { key: '599dcd98d3e3eb290e704ef92058e7f7af05e49f', class: classes }, burger, logo, metaNav, search));
    }
    static get is() { return "dc-ui-header-base"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-base.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-base.css"]
        };
    }
    static get methods() {
        return {
            "returnSearchExpandSize": {
                "complexType": {
                    "signature": "() => Promise<number>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<number>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=dc-ui-header-base.js.map
